import AnimalProtocolSearch from "containers/Form/SimplifiedBuilder/Components/AnimalProtocolSearch";
import COIComponent from "containers/Form/SimplifiedBuilder/Components/COIComponent";
import HaploCostingTool from "containers/Form/SimplifiedBuilder/Components/HaploCostingTool";
import HaploEthicsMonitor from "containers/Form/SimplifiedBuilder/Components/HaploEthicsMonitor";
import HaploRepository from "containers/Form/SimplifiedBuilder/Components/HaploRepository";
import HazardSafetySearch from "containers/Form/SimplifiedBuilder/Components/HazardSafetySearch";
import HumanEthicsStudySearch from "containers/Form/SimplifiedBuilder/Components/HumanEthicsStudySearch";
import ResearchTeamComponent from "containers/Form/SimplifiedBuilder/Components/ResearchTeamComponent";
import S2SIntegrationComponent from "containers/Form/SimplifiedBuilder/Components/S2SIntegrationComponent";
import SummaryBudgetComponent from "containers/Form/SimplifiedBuilder/Components/SummaryBudgetComponent";
import { FundingProgramComponent } from "containers/Form/SimplifiedBuilder/Components/FundingProgram";
import questions from "containers/Form/SimplifiedBuilder/Questions";

export const QUESTIONS = Object.keys(questions)
	.map(question => {
		const { type, name, cayuseType } = questions[question].information;

		return {
			value: cayuseType || type,
			text: name,
			key: cayuseType || type,
		};
	});

export const getSingleColumnComponents = () => {
	const singleColumnComponents = [];
	singleColumnComponents[ResearchTeamComponent.paletteInformation().type] = {
		id: ResearchTeamComponent.paletteInformation().id,
		name: ResearchTeamComponent.paletteInformation().name
	};
	// TODO: Removed and replaced with Summary Budget (08/01/2021). Delete if it is decided they are no longer needed
	// singleColumnComponents[BudgetImporterComponent.paletteInformation().type] = {
	// 	id: BudgetImporterComponent.paletteInformation().id,
	// 	name: BudgetImporterComponent.paletteInformation().name
	// };
	singleColumnComponents[SummaryBudgetComponent.paletteInformation().type] = {
		id: SummaryBudgetComponent.paletteInformation().id,
		name: SummaryBudgetComponent.paletteInformation().name
	};
	singleColumnComponents[COIComponent.paletteInformation().type] = {
		id: COIComponent.paletteInformation().id,
		name: COIComponent.paletteInformation().name
	};
	// TODO: Removed and replaced with Summary Budget (08/01/2021). Delete if it is decided they are no longer needed
	// singleColumnComponents[ResearchTeamBudgetComponent.paletteInformation().type] = {
	// 	id: ResearchTeamBudgetComponent.paletteInformation().id,
	// 	name: ResearchTeamBudgetComponent.paletteInformation().name
	// };
	singleColumnComponents[S2SIntegrationComponent.paletteInformation().type] = {
		id: S2SIntegrationComponent.paletteInformation().id,
		name: S2SIntegrationComponent.paletteInformation().name
	};
	singleColumnComponents[HumanEthicsStudySearch.paletteInformation().type] = {
		id: HumanEthicsStudySearch.paletteInformation().id,
		name: HumanEthicsStudySearch.paletteInformation().name
	};
	singleColumnComponents[AnimalProtocolSearch.paletteInformation().type] = {
		id: AnimalProtocolSearch.paletteInformation().id,
		name: AnimalProtocolSearch.paletteInformation().name
	};
	singleColumnComponents[HazardSafetySearch.paletteInformation().type] = {
		id: HazardSafetySearch.paletteInformation().id,
		name: HazardSafetySearch.paletteInformation().name
	};
	singleColumnComponents[HaploCostingTool.paletteInformation().type] = {
		id: HaploCostingTool.paletteInformation().id,
		name: HaploCostingTool.paletteInformation().name
	};
	singleColumnComponents[HaploEthicsMonitor.paletteInformation().type] = {
		id: HaploEthicsMonitor.paletteInformation().id,
		name: HaploEthicsMonitor.paletteInformation().name
	};
	singleColumnComponents[HaploRepository.paletteInformation().type] = {
		id: HaploRepository.paletteInformation().id,
		name: HaploRepository.paletteInformation().name
	};
	const fundingProgramComponentPalette = FundingProgramComponent.paletteInformation();
	singleColumnComponents[fundingProgramComponentPalette.type] = fundingProgramComponentPalette;

	return singleColumnComponents;
};
